import UnavailableSeat from './UnavailableSeat';

export default UnavailableSeat;
